export default __webpack_public_path__ + "static/Slate_iPhone-e2c1062fa31ddc849c31fbc391fc4d04.png";